import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";

export type AlertVariant = "default" | "destructive" | "success" | "warning";

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
}

const variants: Record<AlertVariant, string> = {
  default: "border-border bg-card text-card-foreground",
  destructive: "border-destructive/35 bg-destructive/8 text-foreground",
  success: "border-success-foreground/25 bg-success text-success-foreground",
  warning: "border-warning-foreground/25 bg-warning text-warning-foreground",
};

export function Alert({ className, variant = "default", ...props }: AlertProps) {
  return <div role="alert" className={cn("grid gap-1 rounded-lg border p-4", variants[variant], className)} {...props} />;
}

export function AlertTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("font-medium", className)} {...props} />;
}

export function AlertDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-sm leading-6 text-current opacity-85", className)} {...props} />;
}
